<ng-container *ngIf="companyInfo">
    <div *ngIf="isShown" class="d-flex align-items-center justify-content-between">
        <span class="nav-link" role="button" (click)="clickToggleOpenChild()">
            <i class="bi"
                [class.bi-chevron-down]="companyInfo.isOpen === true"
                [class.bi-chevron-right]="companyInfo.isOpen === false"></i>
        </span>
        <span class="nav-link flex-grow-1 text-nowrap" role="button"
            [class.bg-light]="isSelected === true"
            (click)="clickItem()">
            <span [class.text-success]="isFound === true">{{companyInfo.companyNm}}</span>
        </span>
        <!-- <span class="d-flex align-items-center">
            <span class="btn btn-sm btn-outline-secondary" role="button"
                (click)="clickItem('add',companyInfo.companyId)">
                자회사 추가
            </span>
            <span class="nav-link flex-grow-1" role="button"
                (click)="clickItem('delete',companyInfo.companyId)">
                <i class="bi bi-dash"></i>
            </span>
        </span> -->
    </div>
    <ng-container *ngIf="companyInfo.children && companyInfo.children.length">
        <ul class="nav flex-column collapse"
            [class.show]="companyInfo.isOpen === true">
            <ng-container *ngFor="let item of companyInfo.children;let idx = index;">
                <li class="nav-item"
                    company-selector-tree-node
                    [companyInfo]="item"
                    (callbackIsOpen)="callbackIsOpenFromChild($event)">
                </li>
            </ng-container>
        </ul>
    </ng-container>
</ng-container>